import { Component, Inject, OnInit } from '@angular/core';
import { PopUpComponent } from '../pop-up.component';
import { Overlay } from '@angular/cdk/overlay';
import { ResizeService } from 'src/app/@shared/services/resize/resize.service';
import { RoutePlanningService } from 'src/app/modules/route-planner/services/route-planning/route-planning.service';
import { POPUP_DATA } from 'src/app/@shared/services/modal/modal.service';
import { StopFullData } from 'src/app/modules/route-planner/interfaces/route-planning/service/@schedule-service.interface';
import { SpecialMessage } from 'src/app/modules/route-planner/interfaces/route-planning/gtfs/special-messages/special-message.interface';
import { eSpecialMessagesEffects } from 'src/app/modules/route-planner/constants/special-messages.constants';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { Direction } from '@angular/cdk/bidi';
import { CLOSE, DAYS_NAMES, HEBREW, IN_TIME, LINE, ALTERNATIVE_STATIONS_LIST, STATION_CANCELLED_UNTIL } from 'src/app/modules/route-planner/constants/multi-language.constants';

@Component({
    selector: 'app-station-canceled-pop-up',
    templateUrl: './station-canceled-pop-up.component.html',
    styleUrls: ['./station-canceled-pop-up.component.scss'],
    standalone: false
})
export class StationCanceledPopUpComponent extends PopUpComponent implements OnInit {

  toDateText: string
  toDayText: string
  toTimeText: string
  stationCancelledUntilText: string
  listAlternativeStationsText: string
  lineText: string

  closeText: string

  direction: Direction
  cancelMessage: SpecialMessage

  constructor(
    routePlanningService: RoutePlanningService,
    resizeService: ResizeService,
    overlay: Overlay,
    private readonly languageService: LanguageService,

    @Inject(POPUP_DATA)
    public readonly data: { station: StopFullData },
  ) {
    super(routePlanningService, resizeService, overlay);
  }

  override ngOnInit(): void {
    super.ngOnInit()
    this.cancelMessage = this.data.station.cancelMessage
    this.initializeMultiLanguageTexts()
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe(language => {
      this.direction = language.direction
      const toDate = this.cancelMessage?.toDate
      const dateObject = new Date(toDate)
      const day = String(dateObject.getDate()).padStart(2, '0')
      const month = String(dateObject.getMonth() + 1).padStart(2, '0')
      const year = dateObject.getFullYear()

      const daysOfWeek = DAYS_NAMES[language.language];
      const dayName = daysOfWeek[dateObject.getDay()]
      const time = dateObject.toTimeString().split(' ')[0].slice(0, 5);

      this.toDateText = `${day}-${month}-${year}`; 
      this.toDayText = language.language == HEBREW.english ? `יום ${dayName}` : dayName
      this.toTimeText = `${IN_TIME[language.language]} ${time}`
      this.stationCancelledUntilText = STATION_CANCELLED_UNTIL[language.language]

      this.listAlternativeStationsText = ALTERNATIVE_STATIONS_LIST[language.language]
      this.lineText = LINE[language.language]
      this.closeText = CLOSE[language.language]
    })
  }
}
